import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import { SessionCallPageShell } from '@/components/session-call/SessionCallPageShell';
import { P2PTranscriptionOnlyPageShell } from '@/components/session-call/P2PTranscriptionOnlyPageShell';
import {
	isSessionCallAccessState,
	type SessionCallLayoutOutletContext,
} from '@/constants/sessionCall';
import { useGetSession } from '@/services';
import { getProfessionalData } from '@/utils/cookies';
import { isP2PTranscriptionOnlySessionType } from '@/utils/sessionType';

const ProfessionalSessaoChamadaPage = () => {
	const { sessionId } = useParams<{ sessionId: string }>();
	const location = useLocation();
	const { setVideoCallHeaderConfig } =
		useOutletContext<SessionCallLayoutOutletContext>();
	const professional = getProfessionalData();
	const professionalDisplayName =
		professional?.first_name?.trim() || undefined;

	const accessState = isSessionCallAccessState(location.state)
		? location.state
		: null;

	const { data: sessionData } = useGetSession(sessionId ?? '', {
		enabled: !!sessionId && accessState?.sessionType == null,
	});

	const sessionType = accessState?.sessionType ?? sessionData?.type;
	const isTranscriptionOnlySession =
		isP2PTranscriptionOnlySessionType(sessionType);

	const shellProps = {
		viewerRole: 'professional' as const,
		viewerDisplayName: professionalDisplayName,
		exitPath: '/profissional/home',
		setVideoCallHeaderConfig,
	};

	if (isTranscriptionOnlySession) {
		return <P2PTranscriptionOnlyPageShell {...shellProps} />;
	}

	return <SessionCallPageShell {...shellProps} />;
};

export { ProfessionalSessaoChamadaPage };
